// extracted by mini-css-extract-plugin
export default {"comingSoonHeading":"coming-soon_comingSoonHeading__Uabp4","comingSoonParagraph":"coming-soon_comingSoonParagraph__GGKcI"};